export const DEFAULT_PAGINATION_ROWS_COUNT = 100;
